import { doc, getDoc, setDoc, serverTimestamp } from "firebase/firestore";

/**
 * Obtiene el workspaceId basado en el estado de autenticación
 * - En desarrollo sin usuario → "local"
 * - Con usuario autenticado → SIEMPRE user.uid (las reglas de Firestore lo requieren)
 * - Sin usuario → null
 */
export function getWorkspaceId(auth) {
  const user = auth.currentUser;

  // En desarrollo sin usuario autenticado
  if (import.meta.env.DEV && !user) {
    console.log("[WORKSPACE] Using LOCAL workspaceId");
    return "local";
  }

  // Sin usuario autenticado
  if (!user) {
    console.warn("[WORKSPACE] No authenticated user");
    return null;
  }

  // Usuario autenticado → SIEMPRE devolver UID (coincide con reglas de Firestore)
  console.log("[WORKSPACE] Using uid as workspaceId:", user.uid);
  return user.uid;
}

/**
 * Crea el documento del workspace en Firestore si no existe
 * Esto garantiza que la estructura base siempre está disponible
 */
export async function createWorkspaceIfMissing(workspaceId, db) {
  if (!workspaceId) {
    console.warn("[WORKSPACE_CREATE] Invalid workspaceId, skipping creation");
    return false;
  }

  try {
    const workspaceRef = doc(db, "workspaces", workspaceId);
    const workspaceSnap = await getDoc(workspaceRef);

    if (workspaceSnap.exists()) {
      console.log("[WORKSPACE_CREATE] Workspace already exists:", workspaceId);
      return true;
    }

    // Workspace no existe, crearlo
    console.log("[WORKSPACE_CREATE] Creating workspace:", workspaceId);
    await setDoc(workspaceRef, {
      workspaceId,
      createdAt: serverTimestamp(),
      env: import.meta.env.DEV ? "local" : "prod",
      _initialized: true
    });

    console.log("[WORKSPACE_CREATE] ✅ Workspace created successfully:", workspaceId);
    return true;
  } catch (error) {
    console.error("[WORKSPACE_CREATE] Error creating workspace:", error);
    throw error;
  }
}
